var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "mb-2" }, [
    _c("div", { class: "row " + _vm.phaseString + "-accordion" }, [
      _c(
        "button",
        {
          staticClass: "btn",
          class: { collapsed: _vm.currentPhase !== _vm.phase },
          attrs: {
            type: "button",
            "data-toggle": "collapse",
            "data-target": "#collapse-" + _vm.phaseString,
            "aria-expanded": _vm.currentPhase === _vm.phase,
            "aria-controls": "collapse-" + _vm.phaseString,
          },
        },
        [
          _c(
            "svg",
            {
              staticClass: "up",
              attrs: {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 320 512",
              },
            },
            [
              _c("path", {
                attrs: {
                  d: "M177 159.7l136 136c9.4 9.4 9.4 24.6 0 33.9l-22.6 22.6c-9.4 9.4-24.6 9.4-33.9 0L160 255.9l-96.4 96.4c-9.4 9.4-24.6 9.4-33.9 0L7 329.7c-9.4-9.4-9.4-24.6 0-33.9l136-136c9.4-9.5 24.6-9.5 34-.1z",
                },
              }),
            ]
          ),
          _c(
            "svg",
            {
              staticClass: "down",
              attrs: {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 320 512",
              },
            },
            [
              _c("path", {
                attrs: {
                  d: "M143 352.3L7 216.3c-9.4-9.4-9.4-24.6 0-33.9l22.6-22.6c9.4-9.4 24.6-9.4 33.9 0l96.4 96.4 96.4-96.4c9.4-9.4 24.6-9.4 33.9 0l22.6 22.6c9.4 9.4 9.4 24.6 0 33.9l-136 136c-9.2 9.4-24.4 9.4-33.8 0z",
                },
              }),
            ]
          ),
          _c("h5", [_vm._v(_vm._s(_vm.$t(_vm.phaseString)))]),
        ]
      ),
    ]),
    _c(
      "div",
      {
        class: [
          { show: _vm.currentPhase === _vm.phase },
          "row collapse " + _vm.phaseString + "-accordion",
        ],
        attrs: { id: "collapse-" + _vm.phaseString },
      },
      [
        _c("phase-header", {
          attrs: { "background-class": _vm.phaseString + "-odd" },
        }),
        _c(
          "div",
          { staticClass: "col-12" },
          _vm._l(_vm.list, function (value, index) {
            return _c(
              "div",
              {
                key: index,
                staticClass: "row item pt-2 pb-2",
                class: index % 2 === 1 ? _vm.phaseString + "-odd" : "",
              },
              [
                _c("div", { staticClass: "col-1" }, [
                  _vm._v(" " + _vm._s(value.outageMilestoneId) + ". "),
                ]),
                _c("div", { staticClass: "col-4" }, [
                  _vm._v(" " + _vm._s(value.description) + " "),
                ]),
                _c("div", { staticClass: "col-2" }, [
                  _vm._v(
                    " " + _vm._s(_vm.getTimeframeLabel(value.timeframe)) + " "
                  ),
                  _vm.shouldShowInfo(value)
                    ? _c(
                        "a",
                        {
                          attrs: {
                            role: "button",
                            "data-toggle": "popover",
                            "data-placement": "bottom",
                            "data-content":
                              "Calculated based on the latest date of outage approval.",
                          },
                        },
                        [
                          _c("font-awesome-icon", {
                            attrs: { icon: "info-circle" },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                ]),
                value.inputType === _vm.kpiInputTypes.number
                  ? _c(
                      "div",
                      { staticClass: "col-2 input-group input-group-sm" },
                      [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model.number",
                              value: value.numericValue,
                              expression: "value.numericValue",
                              modifiers: { number: true },
                            },
                          ],
                          staticClass: "form-control from-control-sm",
                          attrs: { type: "number", min: "0", max: "100" },
                          domProps: { value: value.numericValue },
                          on: {
                            blur: [
                              function ($event) {
                                return _vm.enforcePercentage(value)
                              },
                              function ($event) {
                                return _vm.$forceUpdate()
                              },
                            ],
                            input: function ($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                value,
                                "numericValue",
                                _vm._n($event.target.value)
                              )
                            },
                          },
                        }),
                        _vm._m(0, true),
                      ]
                    )
                  : _vm._e(),
                value.inputType === _vm.kpiInputTypes.checkbox
                  ? _c("div", { staticClass: "col-2" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: value.booleanValue,
                            expression: "value.booleanValue",
                          },
                        ],
                        attrs: {
                          type: "checkbox",
                          id: _vm.phaseString + "-" + index,
                        },
                        domProps: {
                          value: value.booleanValue,
                          checked: Array.isArray(value.booleanValue)
                            ? _vm._i(value.booleanValue, value.booleanValue) >
                              -1
                            : value.booleanValue,
                        },
                        on: {
                          change: function ($event) {
                            var $$a = value.booleanValue,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = value.booleanValue,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  _vm.$set(
                                    value,
                                    "booleanValue",
                                    $$a.concat([$$v])
                                  )
                              } else {
                                $$i > -1 &&
                                  _vm.$set(
                                    value,
                                    "booleanValue",
                                    $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                  )
                              }
                            } else {
                              _vm.$set(value, "booleanValue", $$c)
                            }
                          },
                        },
                      }),
                    ])
                  : _vm._e(),
                _c(
                  "div",
                  { staticClass: "col-2" },
                  [
                    !value.canHaveMaxScoreAnyTime && value.booleanValue
                      ? _c("date-picker", {
                          attrs: {
                            type: "date",
                            "value-type": "format",
                            format: "YYYY-MM-DD",
                            "disabled-date": _vm.disabledAfterToday,
                            "input-class": [
                              {
                                "is-invalid":
                                  (value.booleanValue &&
                                    !value.completionDate) ||
                                  _vm.getValidateObject(
                                    "outageScorecardValues[" +
                                      (value.outageMilestoneId - 1) +
                                      "].CompletionDate"
                                  ),
                              },
                              "form-control form-control-sm",
                            ],
                          },
                          model: {
                            value: value.completionDate,
                            callback: function ($$v) {
                              _vm.$set(value, "completionDate", $$v)
                            },
                            expression: "value.completionDate",
                          },
                        })
                      : _vm._e(),
                    _vm.getValidateObject(
                      "outageScorecardValues[" +
                        (value.outageMilestoneId - 1) +
                        "].CompletionDate"
                    )
                      ? _c(
                          "div",
                          { staticClass: "invalid-feedback d-block" },
                          _vm._l(
                            _vm.getValidateObject(
                              "outageScorecardValues[" +
                                (value.outageMilestoneId - 1) +
                                "].CompletionDate"
                            ),
                            function (error) {
                              return _c("span", { key: error }, [
                                _vm._v(_vm._s(error)),
                              ])
                            }
                          ),
                          0
                        )
                      : _vm._e(),
                    value.hasAdditionalDate && value.booleanValue
                      ? _c("date-picker", {
                          attrs: {
                            type: "date",
                            "value-type": "format",
                            format: "YYYY-MM-DD",
                            "input-class": [
                              {
                                "is-invalid":
                                  value.booleanValue && !value.additionalDate,
                              },
                              "form-control form-control-sm",
                            ],
                          },
                          model: {
                            value: value.additionalDate,
                            callback: function ($$v) {
                              _vm.$set(value, "additionalDate", $$v)
                            },
                            expression: "value.additionalDate",
                          },
                        })
                      : _vm._e(),
                    value.hasAdditionalDate && value.booleanValue
                      ? _c(
                          "small",
                          { staticStyle: { "white-space": "nowrap" } },
                          [_vm._v(" Latest date of outage approval")]
                        )
                      : _vm._e(),
                  ],
                  1
                ),
                _c("div", { staticClass: "col-1" }, [
                  _vm._v(
                    " " +
                      _vm._s(
                        value.score != null ? value.score.toFixed(0) + " %" : ""
                      ) +
                      " "
                  ),
                ]),
              ]
            )
          }),
          0
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "input-group-append" }, [
      _c("span", { staticClass: "input-group-text" }, [_vm._v("%")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }